import React, { useState } from "react";
import Navbar from "../Navbar";
import DatePicker from "../forms/DatePicker";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Box, Button, ThemeProvider, createTheme } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import download from "downloadjs";

import { useNavigate } from "react-router-dom";
// import React, { useEffect, useState } from 'react';
import { Card, Form, Table } from "react-bootstrap";
import { saveAs } from "file-saver";
// import {getCountries, getData} from  '../data/apiData';
// import {ScaleLoader} from 'react-spinners';
// import ReactExport from 'react-data-export';

const DownloadReport = () => {
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [reportInput, setReportInput] = useState({
    startDate: "",
    endDate: "",
    verticle_type: "",
    error_list: [],
  });
  const [sDate, setsDate] = useState("");
  const [eDate, seteDate] = useState("");
  const [vtype, setvtype] = useState("");
  // const handleInput = (e) => {
  //   e.persist();
  //   setReportInput({ ...reportInput, [e.target.name]: e.target.value });
  // };
  const handlesDateChange = (e) => {
    setsDate(e.target.value);
  };

  // const handleedateChange = (e) => {
  //   seteDate(e.target.value);
  // };

  const handlevtypeChange = (e) => {
    setvtype(e.target.value);
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  //   const submitReportData = (e) => {
  //     e.preventDefault();
  //     // let userId = localStorage.getItem("auth_id");
  //     // console.log(userId);

  // //api calling
  // // console.log(data,"MDSKD");
  // const apiUrl = `/api/download_report?startDate=${sDate}&endDate=${eDate}&verticle_type=${vtype}`;

  //     axios.get(apiUrl).then((res) =>{
  //       if(res.data.status === 200){
  //         console.log(res.data.payout);
  //         const report = res.data.payout;
  //         const blob = new Blob([report], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //         saveAs(blob, 'data.xlsx');
  //         // setdata(oldArray => [data,...oldArray] );
  //         // setdata(res.data.payout);
  //         // setdata(oldArray => [data,...oldArray] );
  //         // download(data, 'data.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  //       }
  //       else if(res.data.status === 400){
  //         setReportInput({...reportInput,error_list:res.data.errors});
  //       }
  //     });
  //   };
  const submitReportData = async (e) => {
    e.preventDefault();
    // console.log('sDate',sDate)
    // console.log('vtype',vtype)
     const currentTimestamp = new Date();
    // const formattedDateTime = new Date(currentTimestamp).toLocaleTimeString().replace(/[-:]/g, '');
    const showTime = currentTimestamp.getHours() 
      + '' + currentTimestamp.getMinutes() 
      + "" + currentTimestamp.getSeconds();
    const apiUrl = `/api/download_invoice_excel?month=${sDate}
    &verticle_type=${vtype}`;
    try {
      const response = await axios.get(apiUrl, {
        responseType: "blob", // This indicates that the response is a binary blob
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${vtype}-report-${showTime}.xlsx`;
      link.click();
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="row" style={{ marginTop: 20, width: "97%" }}>
        {/* // <div className="col-sm-1"></div> */}
        <div className="col-sm-12" style={{ marginLeft: 40 }}>
          <div className="card">
            <div className="card-header">
              <h4>
                <b>Download Invoice Details Report</b>
              </h4>
            </div>
            <form onSubmit={submitReportData} id="REPORT_FORM">
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Month</label>
                    <select
                      id="verticle_type"
                      value={sDate}
                      onChange={handlesDateChange}
                      name="month"
                      className="form-control"
                    >
                      <option value="">-- Select Month --</option>
                      <option value="Jan">January</option>
                      <option value="Feb">February</option>
                      <option value="Mar">March</option>
                      <option value="Apr">April</option>
                      <option value="May">May</option>
                      <option value="Jun">June</option>
                      <option value="Jul">July</option>
                      <option value="Aug">August</option>
                      <option value="Sep">September</option>
                      <option value="Oct">October</option>
                      <option value="Nov">November</option>
                      <option value="Dec">December</option>
                    </select>
                  </div>
                  <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                    <label>Invoice Type</label>
                    <select
                      id="verticle_type"
                      value={vtype}
                      onChange={handlevtypeChange}
                      name="verticle_type"
                      className="form-control"
                    >
                      <option value="">-- Invoice Type --</option>
                      <option value="Party Code">BILLING PARTY CODES</option>
                      <option value="CASH">CASH</option>
                      <option value="CASH REC">CASH REC</option>
                      <option value="CASH BAL">CASH BAL</option>
                      <option value="NO BILL">NO BILL</option>
                    </select>
                  </div>
                  <ThemeProvider theme={theme}>
                    <Box
                      marginTop={1}
                      display="flex"
                      padding={3}
                      borderRadius={5}
                      alignItems="center"
                      justifyContent={"center"}
                    >
                      {/*<ThemeProvider theme={theme}>*/}
                      <Button
                        style={{
                          maxWidth: "200px",
                          maxHeight: "100px",
                          minWidth: "50px",
                          minHeight: "30px",
                        }}
                        color="apple"
                        type="submit"
                        variant="contained"
                      >
                        Download
                      </Button>
                    </Box>
                  </ThemeProvider>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadReport;
